"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderWorkspacePickerItem = exports.CoreHeaderWorkspacePickerItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
exports.CoreHeaderWorkspacePickerItem = function (_a) {
    var _b;
    var intl = _a.intl, title = _a.title, isLoading = _a.isLoading, isSelected = _a.isSelected, isDemo = _a.isDemo, onClick = _a.onClick;
    var t = intl.formatMessage;
    if (isLoading) {
        return (react_1.default.createElement("div", { className: "gd-list-item gd-project-list-item gd-is-loading" },
            react_1.default.createElement("div", { className: "gd-spinner small" })));
    }
    var classes = classnames_1.default((_b = {
            "gd-list-item": true,
            "gd-project-list-item": true
        },
        _b["s-" + util_1.stringUtils.simplifyText(title)] = true,
        _b["gd-is-selected"] = isSelected,
        _b["gd-is-demo"] = isDemo,
        _b));
    return (react_1.default.createElement("div", { className: classes, title: title, onClick: onClick },
        react_1.default.createElement("span", { className: "project-title" }, title),
        isDemo && react_1.default.createElement("span", { className: "demo-sticker" }, t({ id: "gs.header.projectPicker.demo" }))));
};
exports.HeaderWorkspacePickerItem = react_intl_1.injectIntl(exports.CoreHeaderWorkspacePickerItem);
//# sourceMappingURL=HeaderWorkspacePickerItem.js.map